var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatcharrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 14,
    viewBox: "0 0 37 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6364 7.6364C36.9879 7.28492 36.9879 6.71508 36.6364 6.3636L30.9088 0.63604C30.5574 0.284568 29.9875 0.284568 29.636 0.63604C29.2846 0.987512 29.2846 1.55736 29.636 1.90883L34.7272 7L29.636 12.0912C29.2846 12.4426 29.2846 13.0125 29.636 13.364C29.9875 13.7154 30.5574 13.7154 30.9088 13.364L36.6364 7.6364ZM0 7.9H18V6.1H0V7.9ZM18 7.9H36V6.1H18V7.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatcharrow);
export default __webpack_public_path__ + "static/media/matcharrow.0b263a0cda4ff77eb93f7b5ebbe611b0.svg";
export { ForwardRef as ReactComponent };